import { createFileRoute } from '@tanstack/react-router'

import { registerPublicFormsInterceptors } from '@/app/router/public-forms-interceptors'
import { OnboardingPage } from '@/pages/onboarding'

export const Route = createFileRoute('/onboarding/')({
  beforeLoad: () => registerPublicFormsInterceptors(),
  component: OnboardingPage,
})

export const OnboardingRoute = Route
